import adminAxiosInstance from "./api/adminAxiosInstance";

// const searchWithdraws = async (limit, offset, order, status, searchTerm) => {
//   const isNumeric = searchTerm && /^\d+$/.test(searchTerm);
//   const params = new URLSearchParams({
//     limit,
//     offset,
//     order,
//     ...(status && { status }),
//     ...(searchTerm && { [isNumeric ? "cpfCnpj" : "name"]: searchTerm }),
//   });
//   const response = await adminAxiosInstance.get("withdraw/search", { params });
//   return response.data;
// };

const searchWithdraws = async (
  limit,
  offset,
  order,
  status,
  searchTerm,
  startDate,
  endDate,
  contractId // Novo parâmetro isolado
) => {
  const isNumeric = searchTerm && /^\d+$/.test(searchTerm);
  const params = new URLSearchParams({
    limit,
    offset,
    order,
    ...(status && { status }),
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
    ...(contractId && { contractId }), // Enviado separadamente
    ...(searchTerm && !isNumeric && { name: searchTerm }),
    ...(searchTerm && isNumeric && { cpfCnpj: searchTerm }),
  });

  const response = await adminAxiosInstance.get("withdraw/search", { params });
  return response.data;
};

const createWithdraw = async (payload) => {
  const response = await adminAxiosInstance.post("withdraw", payload);
  return response.data;
};

const updateWithdrawStatus = async (withdrawId, newStatus) => {
  const response = await adminAxiosInstance.put(
    `withdraw/${withdrawId}/newstatus/${newStatus}`
  );
  return response.data;
};

export const withdrawAdminService = {
  searchWithdraws,
  createWithdraw,
  updateWithdrawStatus,
};
